import { render } from "./DemoCustomersView.vue?vue&type=template&id=604b7e07&scoped=true"
import script from "./DemoCustomersView.vue?vue&type=script&lang=js"
export * from "./DemoCustomersView.vue?vue&type=script&lang=js"

import "./DemoCustomersView.vue?vue&type=style&index=0&id=604b7e07&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604b7e07"]])

export default __exports__